export const formatPrice = (number) => {
    const newNumber = Intl.NumberFormat('en-TN', {
      style: 'currency',
      currency: 'TND',
      minimumFractionDigits : 0
    }).format(number );
    return newNumber;
  };

export const getUniqueValues = (data, type) => {
  let unique = data.map((item) => item[type]);

  if (type === 'colors') {
    unique = unique.flat();
  }

  unique = new Set(unique);
  return ['all', ...unique];
};

export const getSecureUrl = (url) => {
  if (url && url.startsWith('http://')) {
    return url.replace('http://', 'https://');
  }
  return url;
};

export const checkObjectProperties = (obj = {}) => {
  // Return true when any required property is missing/empty (used to determine
  // whether the shipping form still needs editing)
  if (!obj || typeof obj !== 'object') return true;
  const values = Object.values(obj);
  for (const v of values) {
    if (v === null || v === undefined) return true;
    if (typeof v === 'string' && v.trim() === '') return true;
  }
  return false;
};

export const getOrderStatusColor = (status) => {
  if (status === 'processing') {
    return 'var(--clr-orange)';
  }
  if (status === 'rejected') {
    return 'var(--clr-red-dark)';
  }
  return 'var(--clr-green-dark)';
};

export const formatAddress = (data) => {
  const { address, city, state, country, pinCode } = data;
  return `${address}, ${city}, ${state} - ${pinCode}, ${country}`;
};


